/* es5-ext/object/is-value */ function _(require, module, exports) {
    var _undefined = require(307) /* ../function/noop */(); // Support ES3 engines
    module.exports = function (val) {
        return (val !== _undefined) && (val !== null);
    };
}
